import ajaxCall from './ajaxcall';
import report11332 from '../report/11332_batch';
import * as Base from '../base/mbase';
import Env from './env.js';
import wxBridge from 'jsapis/openUrl';
import * as BString from '../base/string';

// DNF、 天刀、 英雄联盟
var jumpDetailList = ['wx165d32c1b8f9bee0', 'wxd9e0d500b5fb209f', 'wx5a611599efa17e78']

function throttle(callback, t) {
    var timer;

    return function () {
        var args = arguments;

        if (timer) {
            return;
        }

        callback.apply(this, args);
        timer = setTimeout(function () {
            timer = null;
        }, t)
    }
}

function Dialog(option) {
    option = option || {}
    option.appitem = option.appitem || {}
    this.option = option
    this.appid = option.appid || option.appitem.AppID || ''
    this.icon = option.appitem.IconURL || ''
    this.name = option.appitem.Name || ''
    this.uiarea = option.uiarea || 3412
    this.scene = option.scene || 34
    this.type = option.type || '预约'
    this.autoDownload = option.autoDownload
    this.wifiChecked = false
    this.hasCard = false
    this.isSelectShowFriend = true; // 个保的选择
    this.isUseFollow = option.appitem.is_use_follow || false;

    this.closeCbk = option.close || function () { }
    this.jumpCbk = option.jumpCbk || function () { }
    this.init()
    this.loadData()

    WXGAME && WXGAME.WxBridge.invoke("setGameTab", {isShowTab: 0})
}

Dialog.prototype.init = function () {
    var self = this
    this.insertStyle()
    this.insertDom()
    this.insertData()
    this.insertButton()

    this.dialogDom = document.querySelector('.appbtn-reserve-dialog')
    this.maskDom = document.querySelector('.appbtn-reserve-dialog__mask')
    this.panelDom = document.querySelector('.appbtn-reserve-dialog__panel')
    this.bottomDom = document.querySelector('.appbtn-reserve-dialog__button')
    setTimeout(function () {
        self.dialogDom.style.bottom = 0
        self.maskDom.style.opacity = 1
        self.panelDom.style.bottom = 0

        self.report({
            aid: 1,
            op: 1
        })
    }, 100)

    this.bindEvent()

    // this.getData().then(function(res) {
    //     if(res.errcode === 0) {
    //         var privilege = res.launch_privilege || {}
    //         self.updateData(privilege)
    //     }else {
    //     }
    // }).catch(function(res) {

    // })
}

Dialog.prototype.loadData = function () {
    var self = this;
    ajaxCall(
        '/cgi-bin/gamewap/getgamebaseextrafor',
        {
            appid: self.appid,
            need_subscribe_info: true,
            need_group_info: true,
            need_wecom_chat_room: true
        },
        function (res) {
            if (res && res.errcode === 0) {
                self.afterLoad(res);
            }
        },
        function () {
        }
    )
}

Dialog.prototype.report = function (obj) {
    var self = this;
    var map = {
        scene: 'iSceneId',
        uia: 'iUIArea',
        pid: 'iPositionId',
        ext: 'sExternInfo',
        aid: 'iActionId',
        op: 'iOpType',
        gid: 'sGameId',
        ssid: 'iSourceSceneId',
        astsuts: 'sActionStatus'
    };

    var defaultRep = {
        gid: self.appid,
        scene: self.scene,
        uia: self.uiarea,
        ssid: self.ssid
    };

    var rep = Base.extend(defaultRep, obj);

    for (var key in rep) {
        if (map[key]) {
            rep[map[key]] = rep[key];

            delete rep[key];
        }
    }

    report11332([rep])
}

Dialog.prototype.getData = function () {
    var self = this;

    return new Promise(function (resolve, reject) {
        ajaxCall(
            '/cgi-bin/gamewap/getgamebaseextrafor',
            {
                appid: self.appid,
                need_launch_privilege: true,
                need_group_info: true
            },
            function (res) {
                resolve(res)
            },
            function () {
                reject()
            }
        )
    })
}

Dialog.prototype.afterLoad = function (data) {
    this.updateData(data)
}

Dialog.prototype.updateData = function (data) {
    var listDom = document.querySelector('.appbtn-reserve-dialog__list')

    this.hasCard = data.subscribe_info && data.subscribe_info.has_wifi_download_card;
    
    var list = [];
    var groupInfo = data.group_info;
    if(groupInfo && data.subscribe_info && data.subscribe_info.has_group) {
        list.push({
            iconUrl: groupInfo.group_icon || this.icon || '',
            title: '去' + (this.name.length > 5 ? (this.name.substring(0, 4) + '... ') : this.name) + '圈看更多内容',
            desc: BString.filterXSS(groupInfo.desc) || '更多资讯活动抢先看',
            showIcon: true,
            iconText: '进入圈子',
            jumpUrl: groupInfo.jump_url || ('https://game.weixin.qq.com/cgi-bin/h5/static/appcenter/singlecircle.html?ssid=3412&appid=' + this.appid),
            type: 'community'
        });
    }

    var roomInfo = data.wecom_chat_room;
    if(roomInfo) {
        list.push({
            iconUrl: roomInfo.icon_url || this.icon || '',
            title: roomInfo.title || '',
            desc: BString.filterXSS(roomInfo.desc) || '更多资讯活动抢先看',
            showIcon: true,
            iconText: '加入官群',
            jumpUrl: roomInfo.jump_url || ('https://game.weixin.qq.com/cgi-bin/h5/static/appcenter/singlecircle.html?ssid=3412&appid=' + this.appid),
            type: 'group'
        });
    }

    if(data.subscribe_info) {
        this.isSelectShowFriend = !data.subscribe_info.blocked_subscribe_info;
        this.originSelectShowFriend = !data.subscribe_info.blocked_subscribe_info;

        if(!this.isSelectShowFriend) {
            let friendIcon = document.querySelector('.appbtn-reserve-dialog__radio-icon');
            if(friendIcon) {
                friendIcon.classList.remove('appbtn-reserve-dialog__radio_checked');
            }
        }
    }

    var dom = document.querySelector('.appbtn-reserve-dialog__content')
    var descDom = document.querySelector('.appbtn-reserve-dialog-desc')
    if (list.length) {
        var html = ''
        for (var i = 0, len = list.length; i < len; i++) {
            var tmpl = [
                '<div class="appbtn-reserve-dialog__item ' + (list[i].jumpUrl ? 'appbtn-reserve-dialog__item-jump' : '') + '" data-url="' + list[i].jumpUrl + '" data-type="' + list[i].type + '">',
                '<div class="appbtn-reserve-dialog__item-icon" style="background-image:url(' + list[i].iconUrl + ')"></div>',
                '<div class="appbtn-reserve-dialog__item-center">',
                '<div class="appbtn-reserve-dialog__item-title">' + (list[i].title || '') + '</div>',
                '<div class="appbtn-reserve-dialog__item-desc">' + (list[i].desc || '') + '</div>',
                list[i].meta ? ('<div class="appbtn-reserve-dialog__item-meta">' + (list[i].meta || '') + '</div>') : '',
                '</div>',
            ]

           if (list[i].showIcon) {
                tmpl = tmpl.concat([
                    '<div class="appbtn-reserve-dialog__item-right">',
                    '<div class="appbtn-reserve-dialog__item-button">' + list[i].iconText + '</div>',
                    '</div>',
                    '</div>'
                ])
            }
            tmpl.push('</div>')

            html += tmpl.join('')
        }

        listDom.innerHTML = html
        if (dom) {
            dom.style.display = 'block'
        }
    } else {

        if (dom) {
            dom.style.display = 'none'
        }

        if(descDom) {
            descDom.style.display = 'none'
        }
    }

    setTimeout(() => {
        this.bindListEvent();

    }, 100)
}

Dialog.prototype.insertStyle = function () {
    var dialogDom = document.getElementById('appbtn-reserve-dialog_style')
    if (!dialogDom) {
        var dom = document.createElement('style')
        dom.setAttribute('type', "text/css")
        dom.setAttribute('id', "appbtn-reserve-dialog_style")

        var style = `
.appbtn-reserve-dialog * {
    box-sizing: border-box !important;
}

.appbtn-reserve-dialog {
    position: fixed;
    left: 0;
    bottom: -100%;
    width: 100%;
    height: 100%;
    z-index: 100002;
}

.appbtn-reserve-dialog__mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.6);
    transition: opacity .1s linear
}

.appbtn-reserve-dialog__panel {
    position: absolute;
    left: 0;
    bottom: -100%;
    width: 100%;
    padding: 0 24px;
    min-height: 300px;
    background: #ffffff;
    border-top-left-radius: 12PX;
    border-top-right-radius: 12PX;
    transition: bottom .3s ease-in-out, height .3s ease-in-out
}
.wg_dark_mode .appbtn-reserve-dialog__panel {
    background: #232323;
}

.appbtn-reserve-dialog__head {
    width: 100%;
    padding: 40px 0 32px 0;
}

.appbtn-reserve-dialog__content {
    display: none
}

.appbtn-reserve-dialog__head-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto;
    background-size: 64px;
    background-repeat: no-repeat;
    background-image: url( https://res.wx.qq.com/wechatgame/product/cdn/moment/done2_50803a7b.svg);
}

.appbtn-reserve-dialog__head-title {
    margin-top: 8px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    font-size: 17px;
    color: rgba(35,35,35,0.90);
    text-align: center;
}

.appbtn-reserve-dialog__head-title-second {
    margin-top: 4px;
}
.wg_dark_mode .appbtn-reserve-dialog__head-title {
    color: rgba(255,255,255,0.8);
}

.appbtn-reserve-dialog-desc {
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.3);
    line-height: 20px;
}
.wg_dark_mode .appbtn-reserve-dialog-desc {
    color: rgba(255,255,255,0.3);
}

.appbtn-reserve-dialog__list {
    width: 100%;
    min-height: 72px;
    position: relative;
    margin-top: 8px;
}

.appbtn-reserve-dialog__list:before {
    content: "";
    width: 200%;
    height: 200%;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    position: absolute;
    transform: scale(.5);
    transform-origin: 0 0;
    transform-origin: 0 0;
    left: 0;
    top: 0;
}
.wg_dark_mode .appbtn-reserve-dialog__list:before {
    border-color: rgba(255,255,255,0.05);
}

.appbtn-reserve-dialog__item {
    width: 100%;
    display: flex;
    position: relative;
    padding: 16px 0;
}

.appbtn-reserve-dialog__item:after {
    content: "";
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    transform: scaleY(.5)
}
.wg_dark_mode .appbtn-reserve-dialog__item:after {
    border-bottom-color: rgba(255,255,255,0.05);
}

.appbtn-reserve-dialog__item:last-child::after {
    display: none;
}

.appbtn-reserve-dialog__item-icon {
    width: 48px;
    height: 48px;
    min-width: 48px;
    margin-right: 12px;
    background-repeat: no-repeat;
    background-size: 48PX 48PX;
    background-position: center;
    border-radius: 8PX;
}

.appbtn-reserve-dialog__item-center {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.appbtn-reserve-dialog__item-title {
    font-family: PingFangSC-Regular;
    line-height: 21px;
    font-size: 15px;
    margin-top: 2px;
    color: rgba(0,0,0,0.90);
    letter-spacing: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 8px;
}
.wg_dark_mode .appbtn-reserve-dialog__item-title {
    color: rgba(255,255,255,0.8);
}

.appbtn-reserve-dialog__item-desc {
    margin-top: 4px;
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: rgba(0,0,0,0.30);
    line-height: 20px;
    width: 100%;
    padding-right: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.wg_dark_mode .appbtn-reserve-dialog__item-desc {
    color: rgba(255,255,255,0.5);
}

.appbtn-reserve-dialog__item-meta {
    margin-top: 4px;
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #FA9D3B;
    line-height: 20px;
}

.appbtn-reserve-dialog__item-meta:before {
    content: "";
    position: relative;
    top: 1px;
    margin-right: 4px;
    display: inline-block;
    width: 12px;
    height: 12px;
    background-image: url(https://res.wx.qq.com/wechatgame/product/cdn/moment/acad8881.svg);
    background-size: 12px 12px;
    background-position: center;
    background-repeat: no-repeat;
}

.appbtn-reserve-dialog__item-right {
    margin-top: 12px;
    flex-shrink: 0;
}

.appbtn-reserve-dialog__item-arrow {
    margin-right: 4px;
    width: 12px;
    height: 22px;
    background-size: 12px 22px;
    background-repeat: no-repeat;
    background-image: url(https://res.wx.qq.com/wechatgame/product/cdn/moment/arrow_4daf6a60.svg)
}

.appbtn-reserve-dialog__item-button {
    font-family: PingFang-SC-Medium;
    font-size: 15px;
    color: #576B95;
    letter-spacing: 0;
    line-height: 21px;
}

.wg_dark_mode .appbtn-reserve-dialog__item-button {
    color: #7D90A9;
}

.wg_dark_mode .appbtn-reserve-dialog__item-arrow {
    background-image: none;
    background-color: #ffffff;
    -webkit-mask-size: 12px 22px;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-image: url(https://res.wx.qq.com/wechatgame/product/cdn/moment/arrow_4daf6a60.svg)
}

.appbtn-reserve-dialog__checkbox {
    width: 45px;
    height: 24px;
    position: relative;
    z-index: 2;
    border: 0;
    background: 0 0;
    appearance: none;
    outline: 0;
}

.appbtn-reserve-dialog__checkbox:before {
    content: "";
    position: relative;
    display: inline-block;
    width: 43px;
    height: 22px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fdfdfd;
    border-radius: 20px;
    cursor: pointer;
    vertical-align: middle;
    box-sizing: content-box;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 0 inset;
    transition: border 0.2s, box-shadow 0.2s;
    background-clip: content-box;
}
.wg_dark_mode .appbtn-reserve-dialog__checkbox:before {
    background-color: #191919;
}

.appbtn-reserve-dialog__checkbox:checked:before {
    border-color: #07C160;
    box-shadow: #07C160 0 0 0 15px inset;
    background-color: #07C160;
    transition: border 0.2s, box-shadow 0.2s, background-color 0.5s;
}

.appbtn-reserve-dialog__checkbox:after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    transition: left 0.2s;
}

.appbtn-reserve-dialog__checkbox:checked:after {
    left: 22px
}

.appbtn-reserve-dialog__bottom {
    width: 100%;
    display: flex;
    padding: 40px 0px 16PX;
    justify-content: center;
    margin: 0 auto;
}

.appbtn-reserve-dialog__button {
    width: 184px;
    height: 40px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    font-family: PingFangSC-Medium;
    font-size: 17PX;
    color: rgb(6, 174, 86);
    varter-spacing: 1px;
    text-align: center;
    line-height: 40px;
}

.appbtn-reserve-dialog__radio{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.3);
    line-height: 20px;
    padding-bottom: 40px;
    width: 200PX;
    margin: 0 auto;
}

.appbtn-reserve-dialog__radio-icon{
    height: 18px;
    width: 18px;  
    background-color: rgba(0, 0, 0, 0);
    margin-right: 6px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.3)
}

.appbtn-reserve-dialog__radio_checked{
    height: 20px;
    width: 20px;
    background-color: #07c160;
    -webkit-mask-image: url("https://res.wx.qq.com/wechatgame/product/cdn/moment/done2_50803a7b.svg");
    -webkit-mask-size: 100% 100%;
    -webkit-mask-repeat: no-repead;
    -webkit-mask-position: center;
    margin-right: 4px;
    border: none;
}

.appbtn-reserve-dialog__radio-text{
    margin: 0;
    padding: 0;
}

.wg_dark_mode .appbtn-reserve-dialog__button {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.8);
}

.wg_dark_mode .appbtn-reserve-dialog__radio-text{
    color: rgba(255, 255, 255, 0.3);
}

.wg_dark_mode .appbtn-reserve-dialog__radio-icon{
    color: rgba(255, 255, 255, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.3);
}

`

        if (Env.isiOS && window.innerHeight > 736) {
            style += `
.appbtn-reserve-dialog__radio{padding-bottom: 70px}
`
        }

        dom.innerHTML = style
        var head = document.getElementsByTagName('head')[0]
        head.appendChild(dom)
    }
}

Dialog.prototype.insertDom = function () {
    var dialogDom = document.getElementById('appbtn-reserve-dialog_dom')
    if (!dialogDom) {
        var dom = document.createElement('div')
        dom.setAttribute('id', "appbtn-reserve-dialog_dom")
        dom.classList.add('appbtn-reserve-dialog')
        if (Env.isDarkMode) {
            dom.classList.add(`wg_dark_mode`)
        }
        let desc = '向好友展示你的预约状态'
        if( this.isUseFollow ) {
          desc = '向好友展示你的关注状态'
        }
        var div = [
            '<div class="appbtn-reserve-dialog__mask"></div>',
            '<div class="appbtn-reserve-dialog__panel">',
                '<div class="appbtn-reserve-dialog__head">',
                    '<div class="appbtn-reserve-dialog__head-icon"></div>',
                    '<div class="appbtn-reserve-dialog__head-title">' + this.type + '成功' + (this.autoDownload ?  '' : '，游戏上线后将通知你') + '</div>',
                    '<div class="appbtn-reserve-dialog__head-title appbtn-reserve-dialog__head-title-second">' +(this.autoDownload ?  '游戏上线后将在 Wi-Fi 下自动下载' : '') + '</div>',
                '</div>',
                '<div class="appbtn-reserve-dialog-desc">你还可以</div>',
                '<div class="appbtn-reserve-dialog__content">',
                '</div>',
                '<div class="appbtn-reserve-dialog__bottom"></div>',
                '<div class="appbtn-reserve-dialog__radio">',
                    '<div class="appbtn-reserve-dialog__radio-icon appbtn-reserve-dialog__radio_checked"></div>',
                    '<p class="appbtn-reserve-dialog__radio-text">' + desc + '</p>',
                '</div>',
            '</div>',
        ]

        dom.innerHTML = div.join('')
        document.body.appendChild(dom)
    }
}

Dialog.prototype.insertData = function () {
    var dom = document.querySelector('.appbtn-reserve-dialog__content')
    var html = '<div class="appbtn-reserve-dialog__list"></div>'

    dom && (dom.innerHTML = html)
}

Dialog.prototype.insertButton = function () {
    var dom = document.querySelector('.appbtn-reserve-dialog__bottom')

    var html = [
        '<div class="appbtn-reserve-dialog__button appbtn-reserve-dialog__button-left">完成</div>',
    ]

    dom.innerHTML = html.join('')
}

Dialog.prototype.bindEvent = function () {
    var self = this
    // this.maskDom.addEventListener('click', function() {
    //     self.closeEvent()
    // })

    this.bottomDom.addEventListener('click', function (e) {
        self.closeEvent()
    })
}

Dialog.prototype.bindListEvent = function () {
    var self = this
    var doms = document.querySelectorAll('.appbtn-reserve-dialog__item-jump');
    for (var i = 0; i < doms.length; i++) {
        var dom = doms[i];
        if (dom) {
            dom.addEventListener('click', throttle(function (e) {
                var url = e.target.getAttribute('data-url');
                var type = e.target.getAttribute('data-type');
                if (!url) {
                    url = e.target.parentNode.getAttribute('data-url')
                    type = e.target.parentNode.getAttribute('data-type');
                    if (!url) {
                        url = e.target.parentNode.parentNode && e.target.parentNode.parentNode.getAttribute('data-url')
                        type = e.target.parentNode.parentNode && e.target.parentNode.parentNode.getAttribute('data-type')
                    }
                }

                if (url) {
                    self.report({
                        pid: 2,
                        aid: url.indexOf('weapp') > -1 ? 71 : 40
                    })
                    self.jumpCbk({type, url});
                    wxBridge.openUrl(url, {ssid: self.uiarea})
                }
            }, 300))
        }
    }

    var checkbox = document.querySelector('.appbtn-reserve-dialog__checkbox')
    if (checkbox) {
        checkbox.addEventListener('click', function () {
            self.report({
                pid: 1,
                aid: 2
            })
        })
    }

    var radio = document.querySelector('.appbtn-reserve-dialog__radio');
    radio.addEventListener('click', function (e) {
        var radioIcon = document.querySelector('.appbtn-reserve-dialog__radio-icon');
        if(!radioIcon) return;

        if(radioIcon.className.indexOf('appbtn-reserve-dialog__radio_checked') > -1) {
            self.isSelectShowFriend = false;
            radioIcon.classList.remove('appbtn-reserve-dialog__radio_checked')
        }else {
            self.isSelectShowFriend = true;
            radioIcon.classList.add('appbtn-reserve-dialog__radio_checked')
        }
    })
}

Dialog.prototype.closeEvent = function () {
    var self = this

    var checkbox = document.querySelector('.appbtn-reserve-dialog__checkbox')
    if (checkbox) {
        this.wifiChecked = checkbox.checked
    }

    if(this.isSelectShowFriend !== this.originSelectShowFriend) {
        sendSetGlobalFlag(this.isSelectShowFriend);
    }

    try {
        localStorage.setItem('__reserve_dialog_switch__', checkbox.checked ? '0' : '1');
    } catch (e) {
    }

    self.panelDom.style.bottom = '-100%'
    setTimeout(function () {
        self.maskDom.style.opacity = 0

        WXGAME && WXGAME.WxBridge.invoke("setGameTab", {isShowTab: 1})
    }, 200)
    setTimeout(function () {
        self.dialogDom.style.bottom = '-100%'

        self.dialogDom.parentNode.removeChild(self.dialogDom)
    }, 350)

    this.closeCbk(Env.isiOS ? false : this.wifiChecked, this.hasCard)

    self.report({
        pid: 3,
        aid: 61,
        astsuts: this.wifiChecked ? 1 : 0
    })
}

function sendSetGlobalFlag (showFriend) {
    return new Promise(function (resolve, reject) {
        ajaxCall(
            '/cgi-bin/gamewap/gamemanage',
            JSON.stringify({
                method: 'POST',
                "set_global_flag": {
                    "block_game_subscribe_info": !showFriend
                }
            }),
            function (res) {
                resolve(res)
            },
            function () {
                reject()
            }
        )
    })
}

export default Dialog;